import { createGtag } from 'vue-gtag'

let gtag

if (process.env.NODE_ENV === 'production') {
	gtag = createGtag({
		tagId: 'G-SVXNP4LLL4',
		defer: true,
	})
} else {
	// Do nothing in development.
	gtag = {
		install() {},
	}
}

export default gtag
